import React from 'react';
import VideoPlayer from './PopChild/Video'

const PreviewVideo = ({ setLoadCounter, value, TickerStart, TickerPosition, zInd, CanvasDisplay, index, onePx }) => {

    return (<>
        <div key={index} className={"EditStart " + value.InClass + value.OutClass}
        id={"Preview-"+ value.AnimationId}
            style={{
                display: (!CanvasDisplay ? value.player ? 'inline-block' : 'none' : TickerStart ? (value.startPositionOnTimeline <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline) >= TickerPosition) ? 'inline-block' : 'none' : (value.startPositionOnTimeline + value.startTransitionWidth <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline - value.startTransitionWidth) >= TickerPosition) ? 'inline-block' : 'none'),
                width: value.width, height: value.height, 'VendorAnimationDuration': '.5s',
                zIndex: zInd, 
                transform: CanvasDisplay ? `rotate(${value.rotateAngle}deg) ` + value.flip : value.flip,
                left: value.x, top: value.y
            }}>
            <VideoPlayer setLoadCounter={setLoadCounter} value={value} onePx={onePx} TickerPosition={TickerPosition} CanvasDisplay={CanvasDisplay} />
        </div>
    </>);
};


export default PreviewVideo;